import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { ConnectionService } from '@services/connection-service';
import { ClinicalTechnologyHighlights } from '../../static-translations/treatment-content-translations';
import { LanguageService } from '@services/language-service/language.service';

@Component({
  selector: 'clinical-technology',
  imports: [],
  templateUrl: './clinical-technology.component.html',
  standalone: true,
})
export class ClinicalTechnologyComponent implements OnInit {
  user: Table.User;
  displayLanguage: string;
  protected readonly ClinicalTechnologyHighlights = ClinicalTechnologyHighlights;

  constructor(
    private readonly router: Router,
    private readonly conn: ConnectionService,
    private readonly languageService: LanguageService
  ) { }

  ngOnInit(): void {
    this.user = this.conn.getActingUser();
    this.displayLanguage = this.languageService.getDisplayLanguage(this.user?.get('languagePreference'));
  }

  back(): void {
    this.router.navigate(['/user'], { queryParams: { tab: 'home' } });
  }
}
